import React, { useState } from "react"
import type { FormProps } from "antd"
import { Card, Flex, Form, Input } from "antd"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Button } from "../../components/Button"
import { systemLogin } from "../../services/systemLogin"
import { useNotification } from "../../context/Notification"
import { HOME } from "../../routes"

type FieldType = {
  username: string
  password: string
}

export const SystemLogin: React.FC = () => {
  const { t } = useTranslation()
  const [isLoading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { error } = useNotification()

  const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
    setLoading(true)

    const response = await systemLogin(values.username, values.password)

    if (!response.ok) {
      error(
        t("systemLogin.notifications.error.message"),
        t("systemLogin.notifications.error.invalidCredentials")
      )
      setLoading(false)
      return
    }

    navigate(HOME)
  }

  return (
    <Flex justify="center" align="center" style={{ minHeight: "60vh" }}>
      <Card title={t("systemLogin.title")} style={{ width: 360 }}>
        <Form
          name="systemLoginForm"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item<FieldType>
            label={t("login.username")}
            name="username"
            rules={[{ required: true, message: t("login.usernameEmptyError") }]}
          >
            <Input />
          </Form.Item>

          <Form.Item<FieldType>
            label={t("login.password")}
            name="password"
            rules={[{ required: true, message: t("login.passwordEmptyError") }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button
              label={isLoading ? t("login.checking") : t("login.login")}
              type="primary"
              htmlType="submit"
              loading={isLoading}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Form>
      </Card>
    </Flex>
  )
}
